module.exports = __webpack_public_path__ + "static/media/settings.592dce64.svg";